/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useState } from 'react';
import { getEnumList } from '@/services/dict';
import { getQueryParam, isPreviewMode, isTemplateMode } from '@/utils/tool'; // 获取数据字典列表 查询入参 country：国籍 city：省市 district：省市区 bank：银行： occupation：职业

const useEnum = (type, format, auto = true) => {
  const [list, setList] = useState([]);
  const fetchEnum = useCallback(() => {
    const {
      goodsId
    } = getQueryParam();
    getEnumList(type, goodsId).then(({
      success,
      result
    }) => {
      if (!success) return;

      if (typeof format === 'function') {
        setList(format(result));
      } else {
        setList(result);
      }
    });
  }, [type]);
  useEffect(() => {
    if (isPreviewMode() || isTemplateMode() || !auto) {
      return;
    }

    fetchEnum();
  }, [fetchEnum]);
  return [list, fetchEnum, setList];
};

export default useEnum;